import { Link } from "@tanstack/react-router";

import { HelixMark } from "@/components/helix";

export function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-border/60 bg-secondary/40">
      <div className="mx-auto max-w-6xl px-5 py-12">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 text-primary">
              <HelixMark className="size-6" />
              <span className="font-display text-base text-foreground">Understand Your Genome</span>
            </div>
            <p className="mt-3 text-sm text-muted-foreground">
              We annotate your genetic test file with data from public databases — so you can
              explore it without looking up every variant yourself.
            </p>
          </div>
          <nav className="flex flex-col gap-2 text-sm">
            <Link to="/" className="text-muted-foreground hover:text-foreground">
              Home
            </Link>
            <Link to="/auth" className="text-muted-foreground hover:text-foreground">
              Sign in
            </Link>
            <Link to="/dashboard" className="text-muted-foreground hover:text-foreground">
              My uploads
            </Link>
            <Link to="/account" className="text-muted-foreground hover:text-foreground">
              Account &amp; data
            </Link>
            <Link to="/privacy" className="text-muted-foreground hover:text-foreground">
              Privacy
            </Link>
            <Link to="/feedback" className="text-muted-foreground hover:text-foreground">
              Feedback
            </Link>
            <a
              href="https://ko-fi.com/understandyourgenome"
              target="_blank"
              rel="noreferrer"
              className="text-muted-foreground hover:text-foreground"
            >
              Support this project
            </a>
          </nav>
        </div>
        <p className="mt-10 rounded-2xl border border-border bg-card p-4 text-xs leading-relaxed text-muted-foreground">
          <strong className="font-semibold text-foreground">This is education, not a diagnosis.</strong>{" "}
          Everything here is meant to help you understand your data. It is not a medical test result
          and cannot tell you whether you have a condition. Please talk to a doctor or a genetic
          counselor (a specialist trained to explain genetic results) about anything that worries
          you.
        </p>
        <p className="mt-4 text-xs text-muted-foreground/50">build {__APP_VERSION__}</p>
      </div>
    </footer>
  );
}

/** Inline version of the disclaimer for use inside pages and result views. */
export function DisclaimerNote({ className }: { className?: string }) {
  return (
    <p
      className={
        "rounded-2xl border border-accent/40 bg-accent/10 p-4 text-sm leading-relaxed text-foreground " +
        (className ?? "")
      }
    >
      <strong className="font-semibold">Educational information, not a diagnosis.</strong> Nothing
      on this page is a medical test result. If something here concerns you, bring it to a doctor or
      a genetic counselor — they can look at your full health picture.
    </p>
  );
}
